var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInverse(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 615 615",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M614.88,307.2c-0,169.662 -137.538,307.2 -307.2,307.2c-169.662,0 -307.2,-137.538 -307.2,-307.2c-0,-169.662 137.538,-307.2 307.2,-307.2c169.662,-0 307.2,137.538 307.2,307.2Zm-191.508,29.28c23.997,-26.975 24.484,-67.88 0.513,-95.46c-2.158,-2.481 -3.446,-3.964 -3.446,-3.964c-0,0 -65.425,-62.423 -111.646,-106.523c-24.894,-23.752 -64.191,-23.29 -88.519,1.037c-2.168,2.169 -2.167,5.687 0.002,7.855l148.895,148.896l-62.148,62.149c-1.48,1.479 -1.479,3.877 -0,5.356l0,0.001c12.886,12.886 30.364,20.125 48.587,20.125c18.224,0 35.702,-7.239 48.588,-20.125l16.239,-16.24l0.002,0.002c0.144,-0.144 0.287,-0.288 0.429,-0.433l2.59,-2.59l-0.086,-0.086Zm-215.997,-52.631l0,203.975c0,3.597 1.429,7.046 3.972,9.59c2.543,2.541 5.992,3.97 9.588,3.97l40.283,0c3.596,0 7.045,-1.429 9.588,-3.97c2.543,-2.544 3.971,-5.993 3.971,-9.59l0,-260.263c0,-1.474 -0.585,-2.887 -1.627,-3.929c-1.043,-1.043 -2.456,-1.628 -3.93,-1.628c-16.403,-0 -32.132,6.516 -43.731,18.114c-11.598,11.598 -18.114,27.328 -18.114,43.731Z",
    style: {
      fill: "#fff"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInverse);
export default __webpack_public_path__ + "static/media/Inverse.02ebac35d44d2e6710eef3328d25416f.svg";
export { ForwardRef as ReactComponent };